export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const lenis = window.__lenis;
  if (lenis) {
    lenis.scrollTo(el, { duration: 1.3, offset: 0 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
